/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useRef, useState } from "react";
// import { Avatar_02, Avatar_16 } from "../../../Routes/ImagePath";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../components/Breadcrumbs";
import axios from "axios";
import { Api_Url } from "../../../config/config";

const Profile = () => {

  const [userProfile, setuserProfile] = useState(null)
  const [alertMessage, setAlertMessage] = useState(null)

  const FetchImage = async () => {
    const id = JSON.parse(sessionStorage.getItem('user'))?.id
    const response = await axios.get(`${Api_Url}api/v1/UserProfile/${id}`)
    console.log("MY Data", response?.data?.data)
    // if (response.) {

    // }
    setuserProfile(response.data?.data)
    sessionStorage.setItem("profile", JSON.stringify(response.data?.data))
  }
  useEffect(() => {
    FetchImage()
  }, [])

  // useEffect(() => {
  //   if (alertMessage) {
  //     const timer = setTimeout(() => {
  //       setAlertMessage(null);
  //     }, 3000); 
  //   }
  // }, [alertMessage]);



  const [changeProfileImage, setChangeProfileImage] = useState({
    ProfileImage: null,
    UserId: null,
    Latitude: "",
    Longitude: ""
  });

  const fileInputRef = useRef(null);

  useEffect(() => {
    // Retrieve user data from session storage when the component mounts
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (user && user.id) {
      setChangeProfileImage((prevState) => ({
        ...prevState,
        UserId: user.id
      }));
      FetchImage(user.id); // Fetch image if needed
    }
  }, []);

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setChangeProfileImage((prevState) => ({
          ...prevState,
          Latitude: latitude.toString(),
          Longitude: longitude.toString()
        }));
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleProfileClick = (e) => {
    e.preventDefault(); // Prevent the default action of the Link
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // console.log('Selected file:', file);

      const formData = new FormData();
      formData.append("ProfileImage", file);
      formData.append("UserId", changeProfileImage.UserId);
      formData.append("Latitude", changeProfileImage.Latitude);
      formData.append("Longitude", changeProfileImage.Longitude);

      try {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const response = await axios.post(
          `${Api_Url}api/v1/UserProfile/${user.id}/save-profile-image`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        if (response.data.ssucceeded === true) {
          setAlertMessage({ type: 'error', text: 'Oops!! try Again..' });
        } else {
          setAlertMessage({ type: 'success', text: 'Image Updated Successfully..😋😋😋'});
        }
        FetchImage()
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  // console.log("object", userProfile)
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {alertMessage && (
            <div className={`alert alert-${alertMessage.type === 'success' ? 'primary' : 'danger'}`} role="alert">
              {alertMessage.text}
            </div>
          )}
          <Breadcrumbs
            maintitle="Profile"
            // title="Dashboard"
            subtitle="Profile"
            modal="#add_indicator"
            name="Add New"
          />
          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div className="profile-img">
                        <div>
                          <Link to="#" onClick={handleProfileClick}>
                            <img src={userProfile?.profileImageUrl} alt="User Image" style={{ cursor: 'pointer' }} />
                          </Link>
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            value={changeProfileImage.ProfileImage}
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="profile-basic">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="profile-info-left">
                            <h3 className="user-name m-t-0 mb-0">
                              {userProfile?.firstName} {userProfile?.lastName}
                            </h3>
                            <h6 className="text-muted">{userProfile?.designationName}</h6>
                            {/*  */}<div className="staff-msg">
                              {/* <Link className="btn btn-custom" to="/call/chat">
                                Send Message
                              </Link> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <ul className="personal-info">
                            <li>
                              <div className="title">Phone:</div>
                              <div className="text">
                                <Link to={`tel:${userProfile?.mobile}`}>
                                  {userProfile?.mobile}
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="title">Email:</div>
                              <div className="text">
                                <Link to={`mailto:${userProfile?.email}`}>
                                  {userProfile?.email}
                                </Link>
                              </div>
                            </li>

                            <li>
                              <div className="title">Address:</div>
                              <div className="text">{userProfile?.branchName}</div>
                            </li>
                            <li>
                              <div className="title">Gender:</div>
                              <div className="text">{userProfile?.genderName}</div>
                            </li>
                            <li>

                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
